import PulseLoader from "react-spinners/PulseLoader";

const LoadingOverlay = ({
  color = "#b46c9f",
  blockClicks = false,
  backdropColor = "rgba(0, 0, 0, 0.0)",
}) => {
  if (!blockClicks) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 999999,
          textAlign: "center",
          pointerEvents: "none",
        }}
      >
        <PulseLoader color={color} size={10} />
      </div>
    );
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999999,
        backgroundColor: backdropColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "all",
      }}
    >
      <PulseLoader color={color} size={10} />
    </div>
  );
};

export default LoadingOverlay;
